import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { RequestTokenService } from "../../request-token.service";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { RegisterAccess } from "../../../app/shared/Entities/RegisterAccess";
import { AlocaUsuarioResponsavelSignature } from "../../../app/shared/Signature/AlocaUsuarioResponsavelSignature";
import { CriarCompromissoSignature } from "../../../app/shared/Signature/CriarCompromissoSignature";
import { AtualizarCompromissoSignature } from "../../../app/shared/Signature/AtualizarCompromissoSignature";

const API_URL = `${environment.apiUrl}v1/Account`;

export interface AuthenticateUserCommand {
  email?: string;
  userName?: string;
  password: string;
  permiteTrocarUsuario?: boolean;
}

@Injectable({
  providedIn: 'root'
})

export class AccountService {

  constructor(private http: HttpClient,
    private requestToken: RequestTokenService
  ) {}

  private handleError(error: any): Observable<never> {
    console.error('An error occurred', error);
    return throwError(error);
  }
  
  public SingIn(command: AuthenticateUserCommand, skipAuth: boolean = false): Observable<any>{
    let headers = new HttpHeaders();
    
    // Se não for para pular autenticação, usar o token atual
    if (!skipAuth) {
      headers = this.requestToken.createAuthorizationHeader();
    }
    
    const options = {
      headers: headers,
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/sign-in`, command, options)
    .pipe(
      catchError(this.handleError)
    )
  }
}
